export const GET_TIMELOGS = "GET_TIMELOGS";
export const GET_TIMELOG_BY_ID = "GET_TIMELOG_BY_ID";
export const UPDATE_TIMELOG = "UPDATE_TIMELOG";
export const DELETE_TIMELOG = "DELETE_TIMELOG";
export const CREATE_TIMELOG = "CREATE_TIMELOG";
